import {
  Component,
  OnInit,
  OnChanges,
  Input,
  SimpleChanges,
  ChangeDetectionStrategy
} from "@angular/core";
import { FormGroup, FormArray } from "@angular/forms";
import { UrlSubstringWhitelist, Verb } from "@onsip/common/interfaces/organization-configuration";
import { TopicFormService } from "../../services/topic-form.service";
import { GenericSimpleChange } from "@onsip/common/interfaces/generic-simple-change";

export type PageItem = [Verb, string];

interface PagePickerSimpleChanges extends SimpleChanges {
  initialValue: GenericSimpleChange<UrlSubstringWhitelist>;
}

@Component({
  selector: "onsip-page-picker",
  templateUrl: "./page-picker.component.html",
  styleUrls: ["../topic-write-form.component.scss", "./page-picker.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PagePickerComponent implements OnInit, OnChanges {
  /** the initial whitelist from the config */
  @Input() initialValue: UrlSubstringWhitelist = [];

  /** The verb options for rules */
  ruleTypes: Array<Verb> = [Verb.INCLUDES, Verb.STARTS_WITH, Verb.ENDS_WITH, Verb.EXACT];
  /** the values in the initial UrlSubstringWhitelist that are rules concatted with their index/formControlName */
  rulesArray: UrlSubstringWhitelist = [];

  /** The verb options for exceptions */
  exceptionTypes: Array<Verb> = [Verb.DOES_NOT_INCLUDE, Verb.DOES_NOT_EQUAL];
  /** the values in the initial UrlSubstringWhitelist that are exceptions concatted with their index/formControlName */
  exceptionsArray: UrlSubstringWhitelist = [];

  constructor(private topicForm: TopicFormService) {}

  ngOnInit() {
    if (!this.topicForm.getControl("pages")) this.topicForm.addControl("pages", new FormGroup({}));
  }

  ngOnChanges(changes: PagePickerSimpleChanges) {
    if (changes.initialValue.currentValue) {
      this.rulesArray = [];
      this.exceptionsArray = [];
      changes.initialValue.currentValue.forEach((page: PageItem) => {
        // page is a [Verb, string] pair so check the verb and allocate to appropriate formgroup with an index to act as its form control name
        if (this.ruleTypes.includes(page[0])) this.rulesArray.push(page);
        else if (this.exceptionTypes.includes(page[0])) this.exceptionsArray.push(page);
      });
    }
  }

  onPageRuleFormInit(formGroup: FormArray, type: string): void {
    const pagesForm = this.topicForm.getControl("pages");
    pagesForm instanceof FormGroup && pagesForm.addControl(type, formGroup);
  }
}
